import React from 'react'
import cx from 'classnames'
import { Box } from 'components/layout/Box/Box'

import pie from 'assets/icons/pie.svg'
import menu from 'assets/icons/menu.svg'
import person from 'assets/icons/person.svg'
import { t } from 'ttag'

import {
  translateIntro,
  isStructuredIntro,
} from 'components/common/ScoreCard/descriptions'

import styles from './IntroPage.module.scss'
import reportStyles from '../../Report.module.scss'

export const IntroPage = ({
  isCandidate = false,
  language,
  name,
  scores,
  projectName,
  noCategories,
  noOutcomeFactors,
  noGMA,
}) => {
  const intro = translateIntro(language, isCandidate)
  const structuredIntro = isStructuredIntro(intro)

  const introCopy = structuredIntro
    ? isCandidate
      ? intro[0].paragraphs
      : intro[0].paragraphs[0].split('. ')
    : isCandidate
      ? intro
      : intro[0].paragraphs[0].split('. ')
  const totalScoreCopy = intro[1]
  const personalityScoreCopy = intro[2]
  const showRecruiterScoreSections = Boolean(
    totalScoreCopy && personalityScoreCopy,
  )
  const showPersonalityScoreSection = !isCandidate && showRecruiterScoreSections

  const renderParagraphs = paragraphs =>
    paragraphs.map((par, idx) => (
      <div className={styles.paragraph} key={idx}>
        {par}
      </div>
    ))

  return (
    <Box
      className={cx(reportStyles.container, {
        [reportStyles.candidateContainer]: isCandidate,
      })}
      direction="column"
      id="report"
      data-testid="report"
    >
      <div className={reportStyles.fold} />
      <div
        className={cx(styles.header, { [styles.candidateHeader]: isCandidate })}
      >
        <div className={styles.title}>{t`TEST REPORT`}</div>
        <div className={styles.name}>{name}</div>
        <div className={styles.position}>{`for ${projectName}`}</div>
      </div>
      <div
        className={cx(styles.introSection, {
          [styles.introSectionCandidate]: isCandidate,
        })}
      >
        {isCandidate ? null : (
          <div className={styles.scores}>
            <div className={styles.ebberScore}>
              <div className={styles.scoreNumber}>
                {!isNaN(scores['Ebber Test Score'])
                  ? Math.round(scores['Ebber Test Score'] * 100)
                  : ' - '}
              </div>
              <div className={styles.scoreLabel}>{t`Ebber Score`}</div>
            </div>
            <div className={styles.testScore}>
              <div className={styles.scoreNumber}>
                {noGMA ? ' - ' : Math.round(scores['GMA'] * 100)}
              </div>
              <div className={styles.scoreLabel}>{t`GMA`}</div>
            </div>
            <div className={cx(styles.personalityScore, styles.testScore)}>
              <div className={styles.scoreNumber}>
                {!isNaN(scores['Personality'])
                  ? Math.round(scores['Personality'] * 100)
                  : ' - '}
              </div>
              <div className={styles.scoreLabel}>{t`Personality`}</div>
            </div>
          </div>
        )}
        <div
          className={cx(styles.intro, {
            [styles.candidateIntro]: isCandidate,
          })}
        >
          {isCandidate ? (
            <div className={styles.candidateIntroBox}>
              {renderParagraphs(structuredIntro ? intro[0].paragraphs : intro)}
            </div>
          ) : (
            <>
              <div className={styles.paragraph}>{`${introCopy[0]}.`}</div>
              <br />
              <div className={styles.paragraph}>
                {introCopy.slice(1).join('. ')}
              </div>
            </>
          )}
        </div>
      </div>

      <div
        className={cx(styles.sections, {
          [styles.candidateSections]: isCandidate,
        })}
      >
        {!isCandidate && showRecruiterScoreSections ? (
          <div className={styles.section}>
            <div className={styles.sectionTitle}>
              <img src={pie} alt="" />
              {totalScoreCopy.title}
            </div>
            <div className={styles.paragraph}>{totalScoreCopy.paragraphs}</div>
          </div>
        ) : null}

        {showPersonalityScoreSection ? (
          <div className={styles.section}>
            <div className={styles.sectionTitle}>
              <img src={person} alt="" />
              {personalityScoreCopy.title}
            </div>
            <div className={styles.paragraph}>
              {personalityScoreCopy.paragraphs}
            </div>
          </div>
        ) : null}

        <div className={styles.section}>
          <div className={styles.sectionTitle}>
            <img src={menu} alt="" />
            {t`Report content`}
          </div>
          <ol className={styles.paragraph}>
            {noCategories || isCandidate ? null : <li>{t`Profile match`}</li>}
            {noGMA ? null : <li>{t`General mental ability`}</li>}
            {noOutcomeFactors ? null : <li>{t`Personality report`}</li>}
          </ol>
        </div>
      </div>
    </Box>
  )
}
